import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuthHook } from "../hooks/useAuth";
import { ROUTES } from "../../../utils/constants";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, loading, hasPermission } = useAuthHook();

  if (loading) return null; // or a spinner

  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} />;
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to={ROUTES.HOMEPAGE} />; // or a 403 page
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.string,
};

ProtectedRoute.defaultProps = {
  requiredPermission: null,
};

export default ProtectedRoute;
